import React, { createContext, useContext, useState, useEffect } from "react";

const OrdersContext = createContext();

// Each active-orders route (food / drink / food&drink) mounts its own
// OrdersProvider so the three displays have completely independent state.
// All values are persisted to localStorage so the display survives a page refresh.
export function OrdersProvider({ children }) {
  const [allOrders, setAllOrders] = useState(() => {
    const saved = localStorage.getItem("allOrders");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem("allOrders", JSON.stringify(allOrders));
  }, [allOrders]);

  const [pageIndex, setPageIndex] = useState(() => {
    const saved = localStorage.getItem("pageIndex");
    return saved ? Number(saved) : 0;
  });

  useEffect(() => {
    localStorage.setItem("pageIndex", pageIndex);
  }, [pageIndex]);

  // How many order cards to show on screen at once (configurable via Settings)
  const [ordersPerPage, setOrdersPerPage] = useState(() => {
    const saved = localStorage.getItem("userDefinedVisible"); // key kept for backwards compatibility
    return saved ? Number(saved) : 3;
  });

  useEffect(() => {
    localStorage.setItem("userDefinedVisible", ordersPerPage); // key kept for backwards compatibility
  }, [ordersPerPage]);

  const [fontSize, setFontSize] = useState(() => {
    const saved = localStorage.getItem("fontSize");
    return saved ? Number(saved) : 100;
  });

  useEffect(() => {
    localStorage.setItem("fontSize", fontSize);
  }, [fontSize]);

  return (
    <OrdersContext.Provider
      value={{
        allOrders,
        setAllOrders,
        pageIndex,
        setPageIndex,
        ordersPerPage,
        setOrdersPerPage,
        fontSize,
        setFontSize,
      }}
    >
      {children}
    </OrdersContext.Provider>
  );
}

export function useOrders() {
  return useContext(OrdersContext);
}
